import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';

import homeAnimation from '@/assets/home_lottieAnimation.json';
import { serviceItems } from '@/data/service-items';
import { translate } from '@/translations';

export const ContentSection = () => {
  const { t } = useTranslation('home');

  return (
    <>
      <div className="section bg-background1">
        <div className="flex justify-center">
          <div className="grid grid-cols-1 lg:grid-cols-7 gap-6 md:w-3/4">
            <div className="flex  items-center col-span-3">
              <h1 className="section-title flex justify-self-center">{t('intro1Title')}</h1>
            </div>
            <div className="col-span-4">
              <div className="section-content">{t('intro1Content')}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="section">
        <div className="flex justify-center">
          <div className="grid grid-cols-1 lg:grid-cols-7 gap-6 md:w-3/4">
            <div className="flex  items-center col-span-3 gap-4">
              <h1 className="section-title flex justify-self-center">{t('intro2Title')}</h1>
            </div>
            <div className="col-span-4 grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <div className="border-t-4 rounded-full mb-2 border-t-gray-700 w-6"></div>
                <div className="section-content">{t('intro2Content1')}</div>
              </div>
              <div>
                <div className="border-t-4 rounded-full mb-2 border-t-gray-700 w-6"></div>
                <div className="section-content">{t('intro2Content2')}</div>
              </div>
              <div>
                <div className="border-t-4 rounded-full mb-2 border-t-gray-700 w-6"></div>
                <div className="section-content">{t('intro2Content3')}</div>
              </div>
              <div>
                <div className="border-t-4 rounded-full mb-2 border-t-gray-700 w-6"></div>
                <div className="section-content">{t('intro2Content4')}</div>
              </div>
              <div>
                <div className="border-t-4 rounded-full mb-2 border-t-gray-700 w-6"></div>
                <div className="section-content">{t('intro2Content5')}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <Lottie
            animationData={homeAnimation}
            loop={true}
            autoplay={true}
            style={{ height: 'auto' }}
            className="md:w-4/6"
          />
        </div>
      </div>

      <div className="section bg-dark text-white rounded-lg">
        <div className="md:sticky top-0 bg-dark py-4 text-center z-20">
          <h1 className="section-title">{t('servicesTitle')}</h1>
        </div>

        {serviceItems
          .filter((serviceItem) => serviceItem.homeSection)
          .map((serviceItem) => (
            <div key={serviceItem.type} className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-24">
              <div className="md:sticky top-24 self-start">
                <div className="section-title2 !text-white mb-4">
                  {translate(serviceItem.titleKey)}
                </div>
                <div className="section-content !text-white">
                  {translate(serviceItem.homeSection.description)}
                </div>
              </div>
              <div className="flex justify-center items-center">
                <img
                  src={serviceItem.homeSection.image}
                  className="rounded-lg z-10 h-[50vh]"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
      </div>
    </>
  );
};
